import {
  animate,
  AnimationBuilder,
  AnimationPlayer,
  style,
} from '@angular/animations';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SplashScreenService {
  splashScreenEl: HTMLElement;
  player: AnimationPlayer;

  constructor(
    private readonly animationBuilder: AnimationBuilder,
    private readonly router: Router
  ) {
    this.init();
  }

  private init(): void {
    this.splashScreenEl = document.body.querySelector('#splash-screen');
    if (this.splashScreenEl) {
      this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          take(1)
        )
        .subscribe(() => setTimeout(() => this.hide(), 100));
    }
  }

  show(): void {
    this.player = this.animationBuilder
      .build([
        style({ opacity: '0', zIndex: '99999' }),
        animate('100ms ease', style({ opacity: '1' })),
      ])
      .create(this.splashScreenEl);

    setTimeout(() => this.player.play(), 0);
  }

  hide(): void {
    this.player = this.animationBuilder
      .build([
        style({ opacity: '1' }),
        animate(
          '500ms ease-in-out',
          style({
            opacity: '0',
            display: '-10',
          })
        ),
      ])
      .create(this.splashScreenEl);

    setTimeout(() => this.player.play(), 0);
  }
}
